import { Link } from "react-router-dom";
import type { Star } from "@/types/content";
import { getStarFilms } from "@/lib/content";

interface StarCardProps {
  star: Star;
}

export default function StarCard({ star }: StarCardProps) {
  const works = getStarFilms(star)
    .map((film) => film.title)
    .slice(0, 2);

  return (
    <Link
      to={`/detail/star/${star.id}`}
      className="group flex flex-col items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4 text-center transition-colors hover:border-primary-300 md:p-5"
    >
      <div className="h-20 w-20 overflow-hidden rounded-full bg-background-100 md:h-24 md:w-24">
        <img
          src={star.avatar}
          alt={`${star.name} 明星头像`}
          title={`${star.name} 明星人物 巨乳娱乐资讯网`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-col gap-1">
        <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-600 md:text-base">
          {star.name}
        </h3>
        <p className="text-xs text-foreground-500">
          {star.nationality} · {star.profession}
        </p>
      </div>
      <p className="line-clamp-1 text-xs text-foreground-600">
        代表作：{works.join("、") || "暂无"}
      </p>
    </Link>
  );
}